// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__19wz_","approved":"Status_approved__1NF9E","rejected":"Status_rejected__Kmz-K","expired":"Status_expired__e-h5q","label":"Status_label__3DIyX"};